import { useState } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Modal,
  Form,
  Toast,
} from 'react-bootstrap';
import { submitContactDetailsAction } from '../../apis/apiAction';
import { Toaster, toast } from 'react-hot-toast';

const Subscription = (props) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setShow(false);
    setFormData({ Name: '', email: '' });
  };

  const handleShow = () => setShow(true);
  const [formData, setFormData] = useState({
    Name: '',
    email: '',
  });

  const inputHandler = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const isValidate = () => {
    if (!formData.Name) {
      toast.error('Name is required');
      return false;
    }
    if (!formData.email) {
      toast.error('Email is required');
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error('Enter a valid email');
      return false;
    }
    return true;
  };

  const submitContactDetails = async () => {
    if (!isValidate()) return;
    setLoading(true);
    try {
      let res = await submitContactDetailsAction(formData);
      if (res.status) {
        toast.success('You are Subscribed!!');
        handleClose();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Toaster />
      <section className="getintouch pt-0">
        <Container>
          <Row className="justify-content-center">
            <Col lg={12} className="mb-4 text-center">
              <div className="heading mt-4">
                <h1 className="mb-4 text-white">Why Unitronix?</h1>
                {/* <p>
                  Unlike traditional crypto investment platforms,{' '}
                  <b className="text-white">Unitronix Corp.</b> offers{' '}
                  <b className="text-white">
                    secure, regulated exposure to digital assets
                  </b>{' '}
                  through our{' '}
                  <b className="text-white">publicly traded stock (UTRX),</b>{' '}
                  eliminating the complexities of wallets, private keys, and
                  direct blockchain interactions. With AI-driven risk
                  management, smart contract automation and security mechanism,{' '}
                  <b className="text-white">
                    Unitronix simplifies crypto investing for everyone—from
                    retail investors to asset managers and institutional funds.
                  </b>
                </p> */}
                <p>{props.Why_Unitronix}</p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={12} className="mb-4 text-center">
              <Card>
                <Card.Body>
                  <Row className="getContent justify-content-center align-items-center">
                    <Col lg={6} className=" text-center">
                      <div>
                        <div className="mb-4">
                          <h1 className="fw-semibold text-white mb-0">
                            Join Us in the Future of Digital Investments
                          </h1>
                        </div>
                        <p className="mb-4">
                          {/* Unitronix invites investors, innovators, and
                          institution to collaborate in shaping the future of
                          tokenized assets and decentralized finance. */}
                          {props.joinUsDescription}
                        </p>
                        <Button className="text-black" onClick={handleShow}>
                          Subscribe
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
                <div>
                  <div className="rightshadow">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="811"
                      height="276"
                      viewBox="0 0 811 276"
                      fill="none"
                    >
                      <g filter="url(#filter0_f_522_5675)">
                        <path
                          d="M470.316 274.271C489.094 152.693 662.22 78.5233 799.097 99.6645C935.973 120.806 1031.71 236.502 1012.93 358.08C1004.54 412.402 926.154 430.79 883.506 463.512C830.704 504.024 806.814 551.632 731.095 539.937C661.618 529.206 671.813 466.334 633.13 418.476C595.604 372.049 461.069 334.138 470.316 274.271Z"
                          fill="#5646AC"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_f_522_5675"
                          x="0.920868"
                          y="-372.861"
                          width="1483.3"
                          height="1383.54"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="BackgroundImageFix"
                            result="shape"
                          />
                          <feGaussianBlur
                            stdDeviation="234.47"
                            result="effect1_foregroundBlur_522_5675"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </div>
                  <div className="particleImg">
                    <img src="assets/images/particle.gif" />
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      <Modal show={show} onHide={handleClose} className="border" centered>
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body className="p-4">
          <div className="pb-4 text-center">
            <h3 className="mb-2">Let 's Get In Touch</h3>
          </div>
          <Form>
            <Row>
              <Col lg={12}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>
                    Name <span className="redStar">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.Name}
                    name="Name"
                    onChange={inputHandler}
                  />
                </Form.Group>
              </Col>
              <Col lg={12}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>
                    Email Address <span className="redStar">*</span>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    value={formData.email}
                    name="email"
                    onChange={inputHandler}
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="text-center">
              <Button
                variant="primary"
                onClick={submitContactDetails}
                disabled={loading}
              >
                {loading ? 'Subscribing...' : 'Subscribe'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default Subscription;
